import ButtonRemove from './ButtonRemove'

export default ButtonRemove
